const PERCENT_MAX_DECIMALS = 4;

/**
 * Percent label from a value already in percent units (`18.25` → `"18.25%"`):
 * at least 1 fractional digit, up to 4 only when needed, trailing zeros stripped.
 */
export function formatPercent(value: number | null, empty: string): string {
  if (value === null || Number.isNaN(value)) return empty;
  const s = value.toFixed(PERCENT_MAX_DECIMALS);
  const sign = s.startsWith("-") ? "-" : "";
  const unsigned = sign ? s.slice(1) : s;
  const [intPart, fracRaw = ""] = unsigned.split(".");
  const frac = fracRaw.replace(/0+$/, "") || "0";
  return `${sign}${intPart}.${frac}%`;
}
